import type { IconData } from '@stacksjs/iconify-core'

export const bq1x1: IconData = {
  "body": "<path fill=\"#21468b\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M0 0h512v341.3H0z\"/><path fill=\"#ae1c28\" d=\"M0 0h512v170.7H0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bq1x1
